import CustomSelect, { Option } from "@src/components/CustomSelect";
import { useText } from "@src/components/Text";

export function AddressIdComponent(addressPagedList) {
  const chooseText = useText('choose');
  return (props) => {
    return (
      <CustomSelect
        id={`ticketRestaurant-manageMyCards-activeCardList-addressByUserListQuery-select`}
        {...props}
        placeholder={chooseText}
        height={36}
      >
        {addressPagedList.map((x) => (
          <Option
            id={`ticketRestaurant-manageMyCards-activeCardList-addressByUserListQuery-${x?.addressName}-option`}
            key={x?.id}
            value={x?.id}
          >
            {x?.addressName}
          </Option>
        ))}
      </CustomSelect>
    );
  };
}